// One identifier per browser tab/runtime. Correlation only, never authorization.
let session;
export function collaborationSessionId() {
  if (!session) {
    const cryptoApi = window.crypto;
    session = typeof cryptoApi.randomUUID === "function" ? cryptoApi.randomUUID() :
      "10000000-1000-4000-8000-100000000000".replace(/[018]/g, (c) =>
        (Number(c) ^ (cryptoApi.getRandomValues(new Uint8Array(1))[0] & (15 >> (Number(c) / 4)))).toString(16));
  }
  return session;
}
